<template>
  <div class="q-row get-the-look__row">
    <div class="q-col-12">
      <button class="q-btn q-btn-close-white q-back-to-listing__button q-position-relative" @click="goBack">Wstecz
      </button>
    </div>
  </div>
</template>
<script setup>
import { config } from '@/core/config'

const goBack = () => {
  const goToListing = () => {
    location.search = ''
    location.hash = ''
    return location.href = config.listingUrl
  }

  if (document.referrer.indexOf(window.location.host) !== -1) {
    window.history.back()
  } else {
    goToListing()
  }
}
</script>
<style>
.q-back-to-listing__button::after {
  position: absolute;
  left: -1.5rem;
  top: 0;
  flex-shrink: 0;
  width: 1.5rem;
  height: 1.5rem;
  margin-left: auto;
  content: "";
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  transform: rotate(90deg) translate(25%, -50%) !important;
  background-repeat: no-repeat;
  background-size: 1.5rem;
}
</style>
